<style scoped lang="less">
// /deep/ .el-col-12 {
// 	.usercard {
// 		border-bottom: 1vh solid rgb(251, 202, 50) !important;
// 	}
// }

/deep/ .el-col {
	height: 100%;
}

/* 设置持续时间和动画函数 */
.v-enter-active,
.v-leave-active {
	transition: all 0.8s ease;
}

.v-enter,
.v-leave-to {
	transform: translateX(-100px);
	opacity: 0;
}

.title {
	display: flex;
	align-items: center;
	height: 2rem;
	width: 8rem;
	border-bottom: 1px solid #eeeeee;
	justify-content: space-between;

	/deep/ .el-date-editor .el-range-separator {
		padding: 0 !important;
		line-height: 19px !important;
		font-size: 0.4rem;
	}

	/deep/ .el-range-editor.el-input__inner {
		height: 1.2rem;
		padding: 0 !important;
		border-color: transparent !important;
	}

	/deep/ .el-date-editor .el-range__icon {
		line-height: 19px !important;
	}

	/deep/ .el-date-editor .el-range__close-icon {
		line-height: 19px !important;
	}

	/deep/ .el-input__inner {
		height: 30px;
		line-height: 30px;
		width: 60%;
	}

	/deep/ .el-input__prefix {
		top: -5px;
	}

	.block {
		margin-right: 1rem;
	}
}

.usercard {
	height: 100%;
	padding: 4vh 1rem;
	background: #fbca32;
	border-radius: 10px;
	box-shadow: 5px 5px 5px 0px #886d1a;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: 1rem;

	img {
		width: 8vw;
		height: 8vw;
	}

	.usersxx {
		margin-left: 0.6rem;
		width: 100%;

		.userstitle {
			font-size: 1.2rem;
			color: #333;
			margin-bottom: 1rem;
			font-weight: 700;
		}

		.usersxxs {
			width: 100%;

			li {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin: 1rem 1rem 1rem 0;
				// flex-direction: column;
				font-size: 0.8rem;
				color: #333;
			}
		}
	}
}

.felxs {
	display: flex;
	align-items: normal !important;
	justify-content: normal !important;
	margin: 0 !important;
	flex-direction: column;
}

.usertop {
	height: 100%;
	margin-bottom: 1rem;
	padding-right: 0.4rem;
	// overflow: hidden;

	ul {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 100%;
		height: 100%;
		align-content: flex-start;

		li {
			display: flex;
			flex-direction: column;
			justify-content: center;
			height: 45%;
		}

		.adduserbott {
			height: 2rem;
		}

		.isnum {
			box-shadow: 5px 5px 5px 0px #434343;
			background: linear-gradient(to right, #485b4d, #1f2623);

			.adduserbott {
				height: 2rem;
				color: #57ca22;

				/deep/ .number-grow {
					color: #57ca22;
				}
			}

			.usertopicon {
				color: #fff;
				background-color: rgba(255, 255, 255, 0.3);
			}
		}

		.istime {
			box-shadow: 5px 5px 5px 0px #474876;
			background: linear-gradient(to right, #1c2938, #5ca4e2);

			.adduserbott {
				color: #f32b4e;

				/deep/ .number-grow {
					color: #f32b4e;
				}
			}

			.usertopicon {
				color: #fff;
				background-color: rgba(255, 255, 255, 0.3);
			}
		}

		.iscore {
			margin-bottom: 0;
			box-shadow: 5px 5px 5px 0px #1c7a43;
			background: linear-gradient(to bottom, #20894d, #5f690d);

			.adduserbott {
				color: #cfedc3;

				/deep/ .number-grow {
					color: #ececec;
				}
			}

			.usertopicon {
				color: #fff;
				background-color: rgba(255, 255, 255, 0.3);
			}
		}

		.ishegpere {
			margin-bottom: 0;
			box-shadow: 5px 5px 5px 0px #1177b0;
			background: linear-gradient(to bottom, #1177b0, #179eff);

			.adduserbott {
				color: #ececec;

				/deep/ .number-grow {
					color: #ececec;
				}
			}

			.usertopicon {
				color: #fff;
				background-color: rgba(255, 255, 255, 0.3);
			}
		}

		li {
			width: 48%;
			padding: 1rem 0.8rem;
			margin: 2px 0 1rem 0;
			box-sizing: border-box;
			border-radius: 10px;

			.usertopconten {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: -10px;
			}

			.adduserbott {
				span.el-icon-top {
					color: #57ca22;
				}

				span.el-icon-bottom {
					color: #f32b4e;
				}

				span.el-icon-video-pause {
					color: #ececec;
				}
			}

			.usertopicon {
				color: #57ca22;
				background-color: rgba(255, 255, 255, 1);
			}

			.adduserbott {
				margin-bottom: -10px;
				// color: #fff;
			}

			.usertopcenter {
				color: #fff;

				span {
					font-size: 1rem;
				}

				/deep/ .number-grow {
					color: #fff;
					font-size: 1rem;
				}
			}

			.usertoptitle {
				color: #ececec;
			}

			.usertopicon {
				width: 2.4rem;
				height: 2.4rem;
				margin-right: 0.4rem;
				border: 1px solid transparent;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 1.6rem;
				color: #fff;
				border-radius: 10px;
				background-color: rgba(255, 255, 255, 0.3);
			}
		}
	}
}

.ability {
	width: 100%;
	margin-bottom: 1rem;
	padding: 1rem 0;
	background: #fff;
	border-radius: 5px;
	position: relative;

	.abilitychart {
		position: absolute;
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		top: -11%;
		right: 5%;
		background-color: #fff;
		height: 4rem;
		// border: 1px solid #AFD2F4;
		background-color: #7cb5ec;
		// border-bottom-right-radius: 10px;
		border-top-right-radius: 5rem;
	}

	.abilitybottom {
		width: 60%;
		margin: 1rem auto;

		p {
			display: flex;
			margin-bottom: 1rem;
		}
	}

	.datesactive {
		background-color: #dae0e5 !important;
	}

	.abilitysgn {
		span {
			margin: 0 0.4rem;
			font-size: 1rem;
			font-weight: 700;
		}
	}

	.abilitytitle {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 1rem;
		padding: 0 1rem;

		p {
			font-size: 0.8rem;
			color: #333;
			font-weight: 800;
		}

		.datas {
			border-radius: 5px;

			span {
				padding: 0.8rem;
				background: #f0f0f0;
			}
		}

		button {
			padding: 0.2rem;
			background: #f0f0f0;
			border-radius: 2px;
			letter-spacing: 1px;

			span {
				margin-left: 0.2rem;
			}
		}
	}
}

/deep/ .el-row {
	height: 100%;
}

.ishfive {
	height: 63vh !important;
}

.ishfiveflex {
	display: flex;
	flex-direction: column;

	.usercard {
		height: auto;
	}
}
</style>

<template>
	<div>
		<titles titlename="学员分析" titlecontent="这里可以看到该学生的学习实训状态" :mbx="paths"></titles>
		<div :class="{ ishfive: allhfives }" ref="homeas" style="height: 31vh;overflow: hidden;margin-bottom: 0.2rem;padding: 1rem 0">
			<el-row :gutter="20" style="height: 100%;" :class="{ ishfiveflex: allhfives }">
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div class="usercard" ref="usercard" style="border-bottom: 4vh solid #FBCA32; ">
						<img v-if="tximgurl" :src="tximgurl" alt="" style="border-radius:50%;" />
						<img v-else src="../../images/header.jpg" alt="" style="border-radius:50%;" />
						<div class="usersxx">
							<p class="userstitle">{{ users.ui_realName }}</p>
							<ul class="usersxxs" ref="usersxxs">
								<li :class="{ felxs: cheoxs }">
									<p>
										学号：
										<span>{{ users.ui_joyNumber }}</span>
									</p>
									<p>
										所属学校：
										<span>{{ users.SchoolName }}</span>
									</p>
								</li>

								<li :class="{ felxs: cheoxs }">
									<p>
										班级：
										<span>{{ users.ClaName }}</span>
									</p>
									<p>
										所属专业：
										<span>{{ users.ProName }}</span>
									</p>
								</li>
							</ul>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div class="usertop">
						<ul>
							<li
								v-for="(item, index) in viewuserlist"
								:key="index"
								:class="{ isnum: item.viewuserid == 1, istime: item.viewuserid == 2, iscore: item.viewuserid == 3, ishegpere: item.viewuserid == 4 }"
							>
								<div class="usertopconten">
									<div>
										<p class="usertoptitle">{{ item.title }}</p>
										<p class="usertopcenter">
											<numbergrow :value="item.viewusernum"></numbergrow>
											<span v-if="item.title == '实训合格率'">%</span>
										</p>
									</div>
									<p class="usertopicon">
										<span class="el-icon-date" v-if="item.viewuserid == 1"></span>
										<span class="el-icon-time" v-if="item.viewuserid == 2"></span>
										<span class="el-icon-s-data" v-if="item.viewuserid == 3"></span>
										<span class="el-icon-s-operation" v-if="item.viewuserid == 4"></span>
									</p>
								</div>
								<div class="adduserbott">
									<span class="el-icon-top" v-if="item.adds == 1"></span>
									<span class="el-icon-bottom" v-if="item.adds == 0"></span>
									<span class="el-icon-video-pause" v-if="item.adds == 2"></span>
									<span style="margin-left: 4px;color: #F32B4E;" v-if="item.adds == 0">{{ item.addnumper }}%</span>
									<span style="margin-left: 4px;color: #57CA22;" v-if="item.adds == 1">{{ item.addnumper }}%</span>
									<span style="margin-left: 4px;color: #ccc;" v-if="item.adds == 2">{{ item.addnumper }}%</span>
									<span style="color:#dfdfd6 ;margin-left: 10px;">{{ item.addconten }}</span>
								</div>
							</li>
						</ul>
					</div>
				</el-col>
			</el-row>
		</div>

		<el-row :gutter="20">
			<el-col :span="widths">
				<div class="ability">
					<div class="abilitytitle">
						<p style="font-size: 1rem;">综合能力评估</p>
						<div style="width: 30%;">
							<el-select v-model="isschoolid" style="width: 100%;" size="small" placeholder="请选择设备">
								<el-option v-for="item in isclasslist" :key="item.sx_te_guid" :label="item.te_deviceName" :value="item.sx_te_guid"></el-option>
							</el-select>
						</div>
					</div>
					<el-empty v-if="projelist.length == 0" description="暂无能力评估请参加实训"></el-empty>
					<div style="width: 100%;height: auto;" v-show="projelistshow > 0"><histogramstudent :datetype="'linear'"></histogramstudent></div>
					<div class="abilitybottom">
						<p>
							星级指数：
							<span><el-rate v-model="scores" disabled :max="10" allow-half text-color="#ff9900"></el-rate></span>
						</p>
						<p>
							智能点评：
							<i style="color: red; text-decoration: underline;">{{ notes }}</i>
						</p>
					</div>
				</div>
			</el-col>
			<el-col :span="widths">
				<div class="ability">
					<div class="abilitytitle">
						<p style="font-size: 1rem;">实训时长分析</p>
						<p style="font-size: 1rem;">{{ valuestimer }}年度实训时长</p>
						<div class="title">
							<div class="block"><el-date-picker @change="chengesdata()" v-model="values" type="year" placeholder="选择年"></el-date-picker></div>
						</div>

						<!-- <p class="datas">
							<span :class="{'datesactive':datactive==1}" @click="datactive=1">年</span>
							<span :class="{'datesactive':datactive==2}" @click="datactive=2">月</span>
							<span :class="{'datesactive':datactive==3}" @click="datactive=3">周</span>
						</p> -->
					</div>
					<el-empty v-if="!timershow" description="暂无实训时长请参加实训"></el-empty>
					<div v-show="timershow"><histogramstudent :datetype="'pie'"></histogramstudent></div>
				</div>

				<div class="ability">
					<div class="abilitytitle">
						<p style="font-size: 1rem;">
							实训成绩分析
							<span></span>
						</p>
						<p style="font-size: 1rem;">{{ scresmongs }}份成绩曲线图</p>
						<p class="abilitysgn">
							<span class="el-icon-refresh" style="cursor: pointer;"></span>
							<el-dropdown @command="handleCommand">
								<span class="el-icon-s-tools"></span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for="item in datalist" :key="item" :command="item">{{ item }}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</p>
					</div>

					<el-empty v-if="cjull == 0" description="暂无成绩参加考试/测试"></el-empty>

					<histogramstudent :datetype="'pie1'" v-show="cjull == 1"></histogramstudent>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import numbergrow from '@/components/numberdt/numbergrow.vue';
import histogramstudent from '@/components/chats/histogramstudent.vue';
// import strat from "@/components/strat.vue"
import $ from 'jquery';
import { GetyyTrainEquipmentList } from '@/request/api/dataorder/dataprder.js';
import { getTrainTimeResults, getMyComprehensiveSTA, getMyTrainDetailScoreSTA, GetMyTrainTimeResultsApi, GetMyTrainDetailScoreSTAApi } from '@/request/api/userapi/studenthome.js';
import { getUserSingle } from '@/request/api/mange/mange.js';
import { GetMyTrainResultsModelApi, GetMyComprehensiveSTAApi } from '@/request/api/homesview/yunhomes/yunhom';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			timershow: false,
			projelistshow: false,
			abiltchats: false,
			scoresmouth: '2022/8',
			scresmongs: new Date().getFullYear() + '年' + parseInt(new Date().getMonth() + 1) + '月',
			scresnum: parseInt(new Date().getMonth() + 1),
			values: new Date().getFullYear() + '',
			valuestimer: new Date().getFullYear(),
			// 图表
			chart1: {},
			chart2: {},
			chart3: {},
			// 年月日
			datactive: 1,
			// 星级评估
			scores: 0,
			notes: '',
			// 控制数据
			viewuserlist: [
				{
					viewuserid: 1,
					title: '累计预约次数',
					viewusernum: 0,
					addnumper: 0,
					adds: 0,
					addconten: '与上月比较'
				},
				{
					viewuserid: 2,
					title: '累计实训时长',
					viewusernum: 0,
					adds: 0,
					addnumper: 0,
					addconten: '与上月比较'
				},
				{
					viewuserid: 3,
					title: '实训平均得分',
					viewusernum: 0,
					adds: 2,
					addnumper: 0,
					addconten: '与上月比较'
				},
				{
					viewuserid: 4,
					title: '实训合格率',
					viewusernum: 0,
					adds: 2,
					addnumper: 0,
					addconten: '与上月比较'
				}
			],
			datalist: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			//用户信息
			users: {
				name: '',
				studentid: '',
				sschool: '',
				classlist: '',
				zy: ''
			},
			// 页面尺寸
			widths: 12,
			cheoxs: false,
			Optiondata: [],
			Optiondata2: [],
			Optiondata3: [],
			// 头像
			tximgurl: '',
			// 空盒子状态
			projelist: [],
			cjull: 1,
			allhfives: false,
			resheights: '',

			// 标题
			paths: [
				{
					path: '/information/studenttics',
					name: '学员分析'
				}
			],
			// 学员对象
			studentobj: {},
			//设备
			isschoolid: '',
			isclasslist: []
		};
	},
	beforeMount() {
		this.studentobj = JSON.parse(this.$cookie.get('stindenbin'));
		// console.log(this.studentobj)
		getUserSingle(this.studentobj.ui_guid).then(res => {
			// console.log(res,"获取单条用户信息")
			this.users = res.data.data;
			this.tximgurl = res.data.data.ui_photoPath;
		});
	},
	mounted() {
		// console.log(this.$store.state.width)
		this.chars();
		this.relazy();
		this.getapi();
		if ($(this.$refs.homeas).offset().top < 25 || $(this.$refs.homeas).offset().left < 25) {
			console.log('刷新页面');
			// if(localStorage.getItem("token")){
			// 	window.location.reload()
			// }
		}

		let flag = navigator.userAgent.match(
			/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		);
		if (flag) {
			this.allhfives = true;
		} else {
			this.allhfives = false;
		}
	},
	updated() {},
	created() {
		AppOptions.appEmpty = false;
	},
	watch: {
		async isschoolid(val) {
			// console.log(val, '获取设备id');
			if (val) {
				let MyCompreobj = {
					sx_te_guid: this.isschoolid
				};
				await GetMyComprehensiveSTAApi(MyCompreobj).then(res => {
					// console.log(res, "实训综合能力评估")
					let projelist = [];
					if (res.data.data.list.length > 0) {
						this.projelistshow = true;
						if (this.projelistshow) {
							this.$nextTick(() => {
								this.chars();
							});
						}
						res.data.data.list.forEach(item => {
							let projeobj = {};
							projeobj.name = item.projectName;
							projeobj.max = 110;
							projelist.push(projeobj);
							// item.avgScore * item.projecScore
							this.Optiondata.push(item.projecScore);
						});
						this.projelist = projelist;
						this.$store.commit('changeindicator', projelist);
						this.chart1.setOption(this.$store.state.option);
						// console.log(this.$store.state.option, "当前etch")

						this.notes = res.data.data.notes;
						let nums = res.data.data.score;
						this.scores = Math.floor(nums * 2) / 2;
						// console.log(this.scores)

						localStorage.setItem('score', this.scores);
					} else {
						this.projelist = [];
						this.projelistshow = false;
						// this.$message("暂无数据");
					}
				});
			}
		}
	},
	methods: {
		// 下拉滚动
		handleCommand(command) {
			this.scresmongs = parseInt(new Date().getFullYear()) + '年' + command;
			this.scresnum = command.replace('月', ' ');
			this.gettraintimers();
		},
		gettrans() {
			this.isschoolid = '';
			GetyyTrainEquipmentList(localStorage.getItem('siguid')).then(re => {
				// console.log(re, '获取设备列表列表');
				this.isclasslist = re.data.data;
				if (this.isclasslist.length > 0) {
					this.isschoolid = this.isclasslist[0].sx_te_guid;
				}
			});
		},

		// 更改日期
		chengesdata() {
			// console.log(this.values)
			let date = new Date(this.values);
			let y = date.getFullYear();
			const timeyear = y;
			// console.log(timeyear);
			// this.values = timeyear
			// console.log(this.values)
			this.valuestimer = timeyear;
			let TrainTimeTobj = {
				id: this.studentobj.ui_guid,
				type: 'year',
				parms: timeyear
			};
			// getTrainTimeResults(TrainTimeTobj).then(res => {
			GetMyTrainTimeResultsApi(TrainTimeTobj).then(res => {
				console.log(res, '时长统计');
				let Trainlistdate = [];
				let Optiondata2 = [];
				if (res.data.data && res.data.data.length > 0) {
					this.timershow = true;
					this.$nextTick(() => {
						this.chars();
					});

					res.data.data.forEach(item => {
						Optiondata2.push(item.count);
						Trainlistdate.push(item.date.slice(-2) + '月');
					});
					this.Optiondata2 = Optiondata2;
					this.$store.commit('changechatows', this.Optiondata2);
					this.$store.commit('changemouth', Trainlistdate);
					this.chart2.setOption(this.$store.state.option1);
				} else {
					this.Optiondata2 = [];
					this.$store.commit('changechatows', this.Optiondata2);
					this.$store.commit('changemouth', this.Optiondata2);
					this.chart2.setOption(this.$store.state.option1);
					// this.$message("暂无数据");
					this.timershow = false;
					this.$nextTick(() => {
						this.chars();
					});
				}
			});
		},

		gettraintimers() {
			var date = new Date();
			let TrainTobj = {
				id: this.studentobj.ui_guid,
				month: this.scresnum
			};
			// getMyTrainDetailScoreSTA(TrainTobj).then(res => {
			GetMyTrainDetailScoreSTAApi(TrainTobj).then(res => {
				// console.log(res, "实训详情成绩统计曲线")
				let trainNamelist = [];

				var chart3 = this.$echarts.init(document.getElementById('sxpople'));
				if (res.data.data && res.data.data.length > 0) {
					this.cjull = 1;
					res.data.data.forEach(s => {
						if (trainNamelist.indexOf(s.projectName) < 0) {
							trainNamelist.push(s.projectName);
						}
					});
					let trainlist = [];
					let resultList = [];
					let rees = {};

					trainNamelist.forEach(s => {
						trainlist = res.data.data.filter(t => t.projectName == s);
						rees = {};
						let resultListorder = [];
						trainlist.forEach(is => {
							resultListorder.push(is.score);
						});
						rees.name = s;
						rees.type = 'line';
						rees.data = resultListorder;
						rees.smooth = true;
						resultList.push(rees);
					});
					// console.log(resultList)

					this.Optiondata3 = resultList;

					this.$store.commit('changechathree', this.Optiondata3);
					chart3.setOption(this.$store.state.option2);
				} else {
					this.Optiondata3 = [];
					this.$store.commit('changechathree', this.Optiondata3);
					this.cjull = 0;
				}

				// this.$message("暂无数据");
			});
		},

		async getapi() {
			await this.gettrans();
			this.gettraintimers();
			let uiid = this.studentobj.ui_guid;
			await GetMyTrainResultsModelApi({
				ui_guid: uiid
			}).then(res => {
				console.log(res, '实训统计数据');
				let MyTrainResults = res.data.data;
				this.viewuserlist[0].viewusernum = Math.ceil(MyTrainResults.TotalAppointmentCount);
				this.viewuserlist[0].addnumper = Math.round(MyTrainResults.TotalAppointmentNumber * 100) / 100;
				// .toFixed(2)
				// .toFixed(2)
				if (MyTrainResults.TotalAppointmentNumber >= 0) {
					this.viewuserlist[0].adds = 1;
					this.viewuserlist[0].addconten = '与上月比较';
				} else if (MyTrainResults.TotalAppointmentNumber > 0 && MyTrainResults.TotalAppointmentNumber < 1) {
					this.viewuserlist[0].adds = 2;
					this.viewuserlist[0].addconten = '与上月比较';
				} else {
					this.viewuserlist[0].adds = 0;
					this.viewuserlist[0].addconten = '与上月比较';
				}
				// 实训时长
				this.viewuserlist[1].viewusernum = Math.ceil(MyTrainResults.TotalTrainTimeCount);
				this.viewuserlist[1].addnumper = Math.round(MyTrainResults.TotalTrainTimeNumber * 100) / 100;
				// .toFixed(2)
				if (MyTrainResults.TotalTrainTimeNumber >= 0) {
					this.viewuserlist[1].adds = 1;
				} else if (MyTrainResults.TotalAppointmentNumber > 0 && MyTrainResults.TotalAppointmentNumber < 1) {
					this.viewuserlist[1].adds = 2;
					this.viewuserlist[1].addconten = '与上月比较';
				} else {
					this.viewuserlist[1].adds = 0;
				}
				// 实训得分
				this.viewuserlist[2].viewusernum = Math.ceil(MyTrainResults.AvgTrainTimeScore);
				this.viewuserlist[2].addnumper = Math.round(MyTrainResults.AvgTrainTimeScoreLastTime * 100) / 100;
				// .toFixed(2)
				if (MyTrainResults.AvgTrainTimeScoreLastTime >= 0) {
					this.viewuserlist[2].adds = 1;
				} else if (MyTrainResults.TotalAppointmentNumber > 0 && MyTrainResults.TotalAppointmentNumber < 1) {
					this.viewuserlist[2].adds = 2;
					this.viewuserlist[2].addconten = '与上月比较';
				} else {
					this.viewuserlist[2].adds = 0;
				}
				// 实训得分
				this.viewuserlist[3].viewusernum = Math.ceil(MyTrainResults.PercentTrainScore);
				this.viewuserlist[3].addnumper = Math.round(MyTrainResults.PercentTrainScoreLastTime * 100) / 100;
				// .toFixed(2)
				if (MyTrainResults.PercentTrainScoreLastTime >= 0) {
					this.viewuserlist[3].adds = 1;
				} else if (MyTrainResults.TotalAppointmentNumber > 0 && MyTrainResults.TotalAppointmentNumber < 1) {
					this.viewuserlist[3].adds = 2;
					this.viewuserlist[3].addconten = '与上月比较';
				} else {
					this.viewuserlist[3].adds = 0;
				}
			});
			let TrainTimeTobj = {
				id: uiid,
				type: 'year',
				parms: this.values
			};
			// getTrainTimeResults(TrainTimeTobj).then(res => {
			await GetMyTrainTimeResultsApi(TrainTimeTobj).then(res => {
				// console.log(res, "时长统计")
				let Trainlistdate = [];
				let Optiondata2 = [];
				if (res.data.data && res.data.data.length > 0) {
					this.timershow = true;
					this.$nextTick(() => {
						this.chars();
					});

					res.data.data.forEach(item => {
						Optiondata2.push(item.count);
						Trainlistdate.push(item.date.slice(-2) + '月');
					});
					this.Optiondata2 = Optiondata2;
					this.$store.commit('changechatows', this.Optiondata2);
					this.$store.commit('changemouth', Trainlistdate);
					this.chart2.setOption(this.$store.state.option1);
				} else {
					this.timershow = false;
					this.Optiondata2 = [];
					this.$store.commit('changechatows', this.Optiondata2);
					this.$store.commit('changemouth', this.Optiondata2);
					this.chart2.setOption(this.$store.state.option1);
					this.$nextTick(() => {
						this.chars();
					});
					// this.$message("暂无数据");
				}
			});

			// let MyCompreobj = {
			// 	id: uiid
			// };
			let MyCompreobj = {
				sx_te_guid: this.isschoolid
			};
			await GetMyComprehensiveSTAApi(MyCompreobj).then(res => {
				// console.log(res, "实训综合能力评估")
				let projelist = [];
				if (res.data.data.list.length > 0) {
					this.projelistshow = true;
					if (this.projelistshow) {
						this.$nextTick(() => {
							this.chars();
						});
					}
					res.data.data.list.forEach(item => {
						let projeobj = {};
						projeobj.name = item.projectName;
						projeobj.max = 110;
						projelist.push(projeobj);
						// item.avgScore * item.projecScore
						this.Optiondata.push(item.projecScore);
					});
					this.projelist = projelist;
					this.$store.commit('changeindicator', projelist);
					this.chart1.setOption(this.$store.state.option);
					// console.log(this.$store.state.option, "当前etch")

					this.notes = res.data.data.notes;
					let nums = res.data.data.score;
					this.scores = Math.floor(nums * 2) / 2;
					// console.log(this.scores)

					localStorage.setItem('score', this.scores);
				} else {
					this.projelist = [];
					this.projelistshow = false;
					// this.$message("暂无数据");
				}
			});
		},
		relazy() {
			var usercard = document.querySelector('.usercard');
			if (document.body.clientWidth < 950) {
				this.widths = 24;
				usercard.style.alignItems = 'flex-start';
			} else {
				this.widths = 12;
				usercard.style.alignItems = 'center';
			}

			if (document.body.clientWidth > 1700) {
				usercard.style.borderWidth = '1vh';
			} else {
				usercard.style.borderWidth = '4vh';
			}
		},

		chars() {
			this.$store.commit('changechat', this.Optiondata);

			var chart1 = this.$echarts.init(document.getElementById('sector'));
			this.chart1 = chart1;
			var chart2 = this.$echarts.init(document.getElementById('sxpice'));
			// console.log(this.$store.state.option1)
			this.chart2 = chart2;
			var chart3 = this.$echarts.init(document.getElementById('sxpople'));
			this.chart3 = chart3;

			var usercard = document.querySelector('.usercard');
			chart1.resize();
			chart2.resize();
			chart3.resize();
			const that = this;
			window.onresize = () => {
				return (() => {
					chart1.resize();
					chart2.resize();
					chart3.resize();
					window.screenWidth = document.body.clientWidth;
					that.screenWidth = window.screenWidth;
					if (that.screenWidth < 1258 && that.widths == 12) {
						that.cheoxs = true;
					} else {
						that.cheoxs = false;
					}
				})();
			};
		}
	},
	components: {
		titles,
		numbergrow,
		histogramstudent
		// strat
	}
};
</script>

<style scoped></style>
